<template>
  <div v-if="iconSrc" class="service-box" @click="handLink">
    <nx-image class="service-icon" :src="iconSrc"></nx-image>
  </div>
</template>
<script>
import { getZoneCustomerServiceDetail } from '@/api/public';
import { isInApp } from '@/utils/is';
import serviceIcon from '@/assets/images/icon/service-icon.png';
import { jumpToService } from '@/utils/crossNative';

export default {
  name: 'NxService',
  components: {
  },
  props: {
    // 跳转类型：1：资讯 2：动态(帖子) 3：活动 2009：展厅 3015:我的 3014:小程序展厅
    jumpType: {
      type: String,
      default: () => '',
    },
    imgSrc: {
      type: String,
      default: () => '',
    },
    // 页面名，埋点参数
    viewSource: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      posterSrc: '',
      iconSrc: '',
      detail: {},
    };
  },
  watch: {
    jumpType: {
      handler(value) {
        if (value && !this.imgSrc) {
          // 没有入口图片，根据跳转类型，获取海报图片
          this.getDetail();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 跳转在线客服海报页面
    handLink() {
      const { configType, jumpPath } = this.detail;
      jumpToService({ jumpType: this.jumpType, configType, jumpPath, posterSrc: this.posterSrc, viewSource: this.viewSource });
    },
    async getDetail() {
      const params = {
        jumpType: this.jumpType,
      };
      const { data } = await getZoneCustomerServiceDetail(params);
      this.detail = data || {};
      const { appletEntranceCover = '', appletDetailPicture = '' } = this.detail;
      // app里面使用固定的客服入口图片
      this.iconSrc = 'https://cdn-zone.app-prod.bjev.com.cn/beijing-wechat/images/咨询客服.O2PyX2uW.png'; // isInApp() ? serviceIcon : appletEntranceCover;
      this.posterSrc = appletDetailPicture;
    },
  },
};
</script>
<style scoped lang="scss">
.service-box {
  position: fixed;
  width: 94px;
  height: 90px;
  right: 0px;
  top: calc(50vh - 90px);
  border-radius: 50%;
}
.service-icon{
  width: 100%;
  height: 100%;
}
</style>
